import React from 'react';
import { FiAlertOctagon, FiBarChart2, FiMenu, FiSettings, FiCheck, FiMinus, FiFileText } from "react-icons/fi";


// --- Status Indicator Component ---
const StatusIndicator = ({ label, status }) => {
  let colorClass = 'bg-gray-200';
  let dotColorTailwind = '500';
  let icon = <FiMinus />;

  if (status === 'OK') {
    colorClass = 'bg-green-100 text-green-700 border-green-300';
    dotColorTailwind = '600';
    icon = <FiCheck />;
  } else if (
    status === 'Error' || 
    status === 'missing' || 
    status === 'unreachable' ||
    status === 'insufficient balance' ||
    status === 'invalid key/config' ||
    status === 'sdk missing'
  ) {
    colorClass = 'bg-red-100 text-red-700 border-red-300';
    dotColorTailwind = '600';
    icon = <FiAlertOctagon />;
  } else if (status === 'network error' || status === 'api error') {
    colorClass = 'bg-yellow-100 text-yellow-700 border-yellow-300';
    dotColorTailwind = '600';
    icon = <FiAlertOctagon />;
  }

  return (
    <div className={`flex justify-between items-center p-3 rounded-lg ${colorClass} font-semibold border`}>
      <span>{label}</span>
      <span className="flex items-center space-x-2">
        <span className="capitalize flex items-center space-x-1">
          {icon}
          <span className="text-sm">{status}</span>
        </span>
      </span>
    </div>
  );
};

export default StatusIndicator;